import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { closeSnackbar, SnackbarProvider } from "notistack";
import { ThemeProvider } from "@/components/theme-provider.tsx";
import SocketProvider from "./context/socket.context/socket.context.tsx";
import { SidebarStackProvider } from "./context/sidebar.stack.context.tsx";
import { TwilioProvider } from "./context/twilio.context.tsx";
import { VoiceLeadEngagementProvider } from "./context/voice.lead.engagement.context.tsx";
import { VoiceSentimentProvider } from "./context/voice.sentiment.context.tsx";
import { CallLeadPopupProvider } from "./context/call.lead.popup.context.tsx";
import { X } from "lucide-react";
import { initSentry } from "./lib/sentry.ts";
import { initClarity } from "./lib/clarity.ts";
import { initStaleChunkReload } from "./lib/stale-chunk-reload.ts";
import { ErrorBoundary } from "@sentry/react";
import ErrorFallback from "./components/ErrorFallback.tsx";
import NewLeadNotification from "./components/notifications/new.lead.notification.tsx";
import GlobalNotificationListener from "./components/notifications/global.notification.listener.tsx";

initSentry();
initClarity();
initStaleChunkReload();

declare module "notistack" {
  interface VariantOverrides {
    newLeadNotification: {
      lead: import("./models/call.center.model").TJoinedClient;
    };
  }
}

const AppWithProviders = () => (
  <SnackbarProvider
    hideIconVariant
    maxSnack={3}
    action={(snackbarId) => (<X className="cursor-pointer" onClick={() => closeSnackbar(snackbarId)} />)}
    Components={{
      newLeadNotification: NewLeadNotification,
    }}
  >
    <ThemeProvider defaultTheme="dark">
      <SocketProvider>
        <TwilioProvider>
          <VoiceSentimentProvider>
            <VoiceLeadEngagementProvider>
              <CallLeadPopupProvider>
                <SidebarStackProvider>
                  <ErrorBoundary
                    fallback={({ error }) => (
                      <ErrorFallback error={error} />
                    )}
                  >
                    <GlobalNotificationListener />
                    <App />
                  </ErrorBoundary>
                </SidebarStackProvider>
              </CallLeadPopupProvider>
            </VoiceLeadEngagementProvider>
          </VoiceSentimentProvider>
        </TwilioProvider>
      </SocketProvider>
    </ThemeProvider>
  </SnackbarProvider>
);

const router = createBrowserRouter([
  { path: "*", element: <AppWithProviders /> },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />
);